<div class="{{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="platform-portlet-content" *ngIf="hasData">
		<div class="platform_content_header">
			<div>started</div>
			<div>25% completed</div>
			<div>50% completed</div>
			<div>75% completed</div>
			<div>100% completed</div>
		</div>
		<div
			class="platform_content"
			*ngFor="
				let platformNetwork of platformNetworks
					| paginate: { id: 'platforms_pagination', itemsPerPage: 8, currentPage: pageId };
				index as i;
				let l = count
			"
		>
			<div class="platform_logo" [ngStyle]="{ background: 'url(' + platformNetwork.logoPath + ') no-repeat' }"></div>
			<div class="platform_details">
				<p class="platform_name">{{ platformNetwork.platformName }}</p>
				<p class="platform_impressions">{{ platformNetwork.impressions | number }}</p>
				<p class="platform_impressions_name">impressions</p>
			</div>
			<div class="progress_bar">
				<div class="platform_progressbar_content">
					<div class="platform_progressbar_header">100%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLine"></div>
					</div>

					<div class="platform_progressbar_footer">
						<div class="values"></div>
					</div>
				</div>

				<div class="platform_progressbar_content">
					<div class="platform_progressbar_header">{{ platformNetwork.percent25 }}%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLine"></div>
					</div>

					<div class="platform_progressbar_footer">
						<div class="values">{{ platformNetwork.value25 | number }} views</div>
					</div>
				</div>
				<div class="platform_progressbar_content">
					<div class="platform_progressbar_header">{{ platformNetwork.percent50 }}%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLine"></div>
					</div>

					<div class="platform_progressbar_footer">
						<div class="values">{{ platformNetwork.value50 | number }} views</div>
					</div>
				</div>

				<div class="platform_progressbar_content">
					<div class="platform_progressbar_header">{{ platformNetwork.percent75 }}%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLine"></div>
					</div>

					<div class="platform_progressbar_footer">
						<div class="values">{{ platformNetwork.value75 | number }} views</div>
					</div>
				</div>

				<div class="platform_progressbar_content">
					<div class="platform_progressbar_header">{{ platformNetwork.percent100 }}%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLineLast"></div>
					</div>

					<div class="platform_progressbar_footer">
						<div class="values">{{ platformNetwork.value100 | number }} views</div>
					</div>
				</div>
			</div>
		</div>
		<pagination-template
			#p="paginationApi"
			(pageChange)="pageId = $event"
			id="platforms_pagination"
			class="ctv_featured_networks"
		>
			<ul class="pager">
				<li [class.disabled]="p.isFirstPage()" style="float: left;" class="firstArrow">
					<a (click)="p.setCurrent(1)">
						<span>First</span>
					</a>
				</li>
				<li
					role="button"
					*ngFor="let page of p.pages"
					[class.current]="p.getCurrent() === page.value"
					class="pages"
					style="float: left;"
				>
					<a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
						{{ page.label }}
					</a>
					<a *ngIf="p.getCurrent() === page.value" [class.primary-color]="p.getCurrent() === page.value">
						{{ page.label }}
					</a>
				</li>
				<li [class.disabled]="p.isLastPage()" style="float: left;" class="lastArrow">
					<a (click)="p.setCurrent(p.getLastPage())">
						<span>Last</span>
					</a>
				</li>
			</ul>
		</pagination-template>
	</div>
	<div *ngIf="!hasData" style="display: table; min-height: 800px; width: 100%;">
		<div class="no-data-text">
			<p>No Data Available</p>
		</div>
	</div>
</div>
